import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";
import * as utilsCommodity from "../utils/commodity";

const initialState = {
    commodities: [],
    current: null,
    loading: false,
    saving: false,
    deleting: false
};

export default function commodity(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_COMMODITY:
            newState.loading = true;
            break;

        case actions.SAVING_COMMODITY:
            newState.saving = true;
            break;

        case actions.RECEIVED_COMMODITIES:
            newState.loading = false;
            newState.commodities = utils.mapById(utilsCommodity.flattenCommodityGroup(action.payload));
            break;

        case actions.RECEIVED_COMMODITY:
            newState.loading = false;
            newState.current = action.payload;
            break;

        case actions.SAVED_COMMODITY:
            let found = false;

            for (let i = 0; i < newState.commodities.length; i++) {
                if(newState.commodities[i].id === action.payload.id){
                    found = true;

                    newState.commodities[i] = action.payload;
                }
            }

            if(!found) {
                newState.commodities.add(
                    action.payload
                );
            }

            newState.commodities = utils.mapById(utilsCommodity.flattenCommodityGroup(newState.commodities));
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_COMMODITY:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.DELETING_COMMODITY:
            newState.deleting = true;
            break;

        case actions.DONE_DELETING_COMMODITY:
            newState.deleting = false;
            break;

        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/commodity.js